module.exports = __webpack_public_path__ + "img/Illu_Processing.c7940930.svg";